export const environment = {
  production: false,
  title: 'tst',
  version: 'v1.0',
  apiBaseUrl: 'https://minasidor-tst.mockfjards.se/api',
  airbrake: { id: 593212, key: '2fcbc2a7b10600cd8f75decfe03bc202' },
  turnstileSiteKey: '0x4AAAAAAFVh69C6wwzacz3s'
};
